import { commitMutation } from 'react-relay'
import graphql from 'babel-plugin-relay/macro'

import environment from '../environments/pom/Environment'

const mutation = graphql`
  mutation CreateUserMutation(
    $companyId: ID!
    $firstname: String
    $lastname: String!
    $email: String
    $username: String!
    $password: String!
    $permissions: [PermissionType]!
    $contracts: [Int]
    $billingPartitions: [Int]
  ) {
    Me {
      Company(id: $companyId) {
        createUser(
          firstname: $firstname
          name: $lastname
          email: $email
          salutation: 0
          title: 1
          username: $username
          password: $password
          permissions: $permissions
          contracts: $contracts
          billingPartitions: $billingPartitions
        ) {
          id
        }
      }
    }
  }
`

export default (variables = {}, accessToken, callBack, errorCallBack) => {
  commitMutation(environment(accessToken), {
    mutation,
    variables,
    onCompleted: callBack,
    onError: errorCallBack,
  })
}
